import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const VerticalScrollArea = styled(Box)({
  overflowY: 'auto',
  overflowX: 'hidden',
});
